import { Button, Dialog, styled } from "@mui/material";

export const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "90vw",
    width: "1200px",
    maxHeight: "90vh",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderRadius: "8px",
  padding: "8px 16px",
  "&.MuiButton-containedPrimary": {
    backgroundColor: "#000000",
    color: "white",
    "&:hover": {
      backgroundColor: "#1f1f1f",
    },
  },
}));

// export const InitialNewProjectFormState = {
//   basicCompanyInfo: {
//     companyName: "",
//     industrySector: "",
//     companySize: "",
//     annualRevenueRange: "",
//     geographicLocations: [],
//     yearsInBusiness: "",
//     currentGrowthStage: "",
//     websiteUrl: "",
//   },
//   productServiceDetails: {
//     coreDescription: "",
//     currentProductStage: "",
//     primaryValueProposition: "",
//     keyFeaturesBenefits: [],
//     deliveryMethod: "",
//   },
//   currentMarketPosition: {
//     targetMarketDescription: "",
//     mainCompetitors: [],
//     marketDifferentiators: "",
//   },
//   customerSuccessMetrics: {
//     commonPainPointsSolved: [],
//     typicalRoi: "",
//   },
//   businessGoals: {
//     shortTermRevenueTargets: "",
//     longTermGrowthObjectives: "",
//     targetMarketExpansion: "",
//   },
//   budgetResourceAllocation: {
//     customerAcquisitionCostTargets: "",
//     marketingBudget: "",
//   },
// };

export const InitialNewProjectFormState = {
  basicCompanyInfo: {
    companyName: "AIBillingDashboard",
    industrySector: "SaaS / AI Cost Management",
    companySize: 12,
    annualRevenueRange: "$1M-$5M",
    geographicLocations: ["United States", "Remote"],
    yearsInBusiness: 2,
    currentGrowthStage: "Seed",
    websiteUrl: "https://www.aibillingdashboard.com",
  },
  productServiceDetails: {
    coreDescription:
      "A unified dashboard that helps businesses track, analyze, and optimize spending across all AI services — from LLMs to workflow tools and specialized AI services.",
    currentProductStage: "Beta",
    primaryValueProposition:
      "Complete visibility and cost optimization across your entire AI stack in one dashboard, helping companies save up to 30% on monthly AI spending.",
    keyFeaturesBenefits: [
      "Unified AI Billing Visibility",
      "Cross-Platform Cost Comparison",
      "Comprehensive Usage Analytics",
      "Billing Cycle Tracking",
      "Cost-Saving Recommendations",
    ],
    deliveryMethod: "SaaS Platform",
  },
  currentMarketPosition: {
    targetMarketDescription:
      "AI power users including AI agencies, AI-first startups, SaaS companies integrating AI, solopreneurs, ecommerce managers, CTOs, and finance teams managing growing AI budgets.",
    mainCompetitors: [
      "Individual AI Platform Dashboards",
      "Custom Spreadsheet Solutions",
      "Enterprise Finance Management Tools",
      "AI Development Platforms with Basic Cost Tracking",
    ],
    marketDifferentiators:
      "The only solution offering unified visibility across all major AI providers (OpenAI, Claude, Gemini), workflow tools (Make, Zapier, n8n), and specialized services (Tavily, Pinecone, RunwayML) in one dashboard.",
  },
  customerSuccessMetrics: {
    commonPainPointsSolved: [
      "Juggling between multiple AI billing portals",
      "Unexpected AI cost overruns",
      "Difficulty tracking ROI across different AI services",
      "Lack of visibility into which AI models are most cost-effective",
    ],
    typicalRoi:
      "Average 30% reduction in AI spending within first 3 months, 5+ hours saved monthly on manual cost tracking, and improved budget allocation across AI services.",
  },
  businessGoals: {
    shortTermRevenueTargets:
      "$2M in annual recurring revenue by end of fiscal year",
    longTermGrowthObjectives:
      "Expand platform to support all major AI services, develop predictive cost optimization tools, and establish enterprise partnerships with major AI providers.",
    targetMarketExpansion:
      "Expand to enterprise customers, develop specialized dashboards for vertical-specific AI use cases, and create an API for integration with finance management platforms.",
  },
  budgetResourceAllocation: {
    customerAcquisitionCostTargets:
      "$200 CAC through content marketing, AI influencer partnerships, and targeted advertising on tech platforms",
    marketingBudget:
      "$300,000 annual budget with focus on SEO content creation, AI community engagement, affiliate partnerships, and educational webinars on AI cost optimization",
  },
};
